var React = require('react');

function CarouselRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 33L0 27.8781L11.4 16.5L0 5.12188L5 0L21 16.5L5 33Z"}));
}

CarouselRight.defaultProps = {"width":"21","height":"33","viewBox":"0 0 21 33","fill":"none"};

module.exports = CarouselRight;

CarouselRight.default = CarouselRight;
